module.exports = __webpack_public_path__ + "img/img13.976028c1.svg";